import Vue from 'vue'

// initial state
const getDefaultState = () => {
  return {
    all: {},
    available: []
  }
}

const state = getDefaultState()

// getters
const getters = {
  getAvailable: (state) => () => {
    return state.available
  }
}

// actions
const actions = {

}

// mutations
const mutations = {
  SET_AVAILABLE_CHIMES (state, availableList) {
    Vue.set(state, 'available', availableList)
  },
  SET_CHIMES (state, chimes) {
    for (let chm of chimes) {
      Vue.set(state.all, chm.macId, chm)
    }
  },
  /**
   * Resets object state to initial values set upon creation.
   */
  RESET_STATE (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
